<p-table
  [paginatorDropdownAppendTo]="'body'"
  #table
  [globalFilterFields]="['name', 'type']"
  [paginator]="true"
  [responsiveLayout]="'scroll'"
  [rowsPerPageOptions]="[5, 10, 20]"
  [rows]="10"
  [value]="connections"
  stripedRows
  styleClass="w-full 	rounded-xl shadow-md"
>
  <ng-template pTemplate="caption">
    <div class="flex">
      <p-iconfield class="ml-auto" iconPosition="left">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input
          #inputRef
          (input)="table.filterGlobal(inputRef.value, 'contains')"
          pInputText
          [placeholder]="'common.search' | translate"
          type="text"
        />
      </p-iconfield>
    </div>
  </ng-template>
  <ng-template #header>
    <tr class="uppercase text-xs">
      <th>{{ 'connections.table.name' | translate }}</th>
      <th>{{ 'connections.table.type' | translate }}</th>
      <th class="text-center!">{{ 'connections.table.action' | translate }}</th>
    </tr>
  </ng-template>
  <ng-template #body let-connections>
    <tr class="transition">
      <td class="capitalize">{{ connections.name }}</td>
      <td>
        <p-tag
          [icon]="getIcons(connections.type)"
          [severity]="getSeverity(connections.type)"
          [value]="connections.type"
          class="capitalize text-sm font-medium flex items-center justify-center gap-2"
        ></p-tag>
      </td>
      <td>
        <div class="flex items-center justify-center gap-1">
          <p-button
            (click)="editConnection(connections)"
            [ariaLabel]="'connections.actions.edit' | translate"
            [pTooltip]="'connections.actions.edit' | translate"
            icon="pi pi-pen-to-square"
            severity="secondary"
            styleClass="size-8 hover:text-primary-600!"
            tooltipPosition="top"
            variant="text"
          />
          <lib-delete-modal
            (deleteConnection)="deleteConnection($event)"
            [connection]="connections"
          />
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="4">{{ 'connections.table.empty' | translate }}</td>
    </tr>
  </ng-template>
</p-table>
